import lodashSet from 'lodash.set';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/redux/store';
import { questionnairesApi } from 'app/services/questionnaires';

export type TPleaseProvideDetailsAboutAllUsOwnersincludingYourselfOfTheCorporationRow =
  {
    name: Nullable<string>;
    ssn: Nullable<string>;
    address: Nullable<string>;
    SharesOwnedAtBeginningOfAccountingPeriod: Nullable<string>;
    VotingPower: Nullable<string>;
  };

export type TPleaseProvideDetailsAboutAllNonUsOwnersRow = {
  name: Nullable<string>;
  address: Nullable<string>;
  SharesOwnedAtBeginningOfAcountingPeriod: Nullable<string>;
  SharesOwnedAtEndOfAccountingPeriod: Nullable<string>;
  ifEntitynotAPersonCountryOfIncorporation: Nullable<string>;
  relationToYouifAny: Nullable<string>;
};

export type TPleaseProvideDetailsAboutAllNonUsOwnersOwnershipOfSeparateEntititesRow =
  {
    nonUsOwnerName: Nullable<string>;
    entityName: Nullable<string>;
    entityAddress: Nullable<string>;
    ownershipOrInterestInTrustAsABeneficiary: Nullable<string>;
  };

export type TPleaseProvideDetailsAboutAllUsOwnersincludingYourselfOfTheCorporationInTheTableBelow =
  TPleaseProvideDetailsAboutAllUsOwnersincludingYourselfOfTheCorporationRow[];
export type TPleaseProvideDetailsAboutAllNonUsOwnersInTheTableBelow =
  TPleaseProvideDetailsAboutAllNonUsOwnersRow[];
export type TPleaseProvideDetailsAboutAllNonUsOwnersOwnershipOfSeparateEntititesInTheTableBelow =
  TPleaseProvideDetailsAboutAllNonUsOwnersOwnershipOfSeparateEntititesRow[];

export type UpdateFieldArrayKeysKeys =
  | keyof TPleaseProvideDetailsAboutAllUsOwnersincludingYourselfOfTheCorporationRow
  | keyof TPleaseProvideDetailsAboutAllNonUsOwnersRow
  | keyof TPleaseProvideDetailsAboutAllNonUsOwnersOwnershipOfSeparateEntititesRow;

type UpdateFieldArrayKeys =
  | 'pleaseProvideDetailsAboutAllNonUsOwnersInTheTableBelow'
  | 'pleaseProvideDetailsAboutAllUsOwnersincludingYourselfOfTheCorporationInTheTableBelow'
  | 'pleaseProvideDetailsAboutAllNonUsOwnersOwnershipOfSeparateEntititesInTheTableBelow';

type UpdateFieldArrayValue =
  | TPleaseProvideDetailsAboutAllUsOwnersincludingYourselfOfTheCorporationInTheTableBelow
  | TPleaseProvideDetailsAboutAllNonUsOwnersInTheTableBelow
  | TPleaseProvideDetailsAboutAllNonUsOwnersOwnershipOfSeparateEntititesInTheTableBelow;

export interface NonUsCorpOfPartnershipStateValues {
  nameOfCorporation: Nullable<string>;
  whatDoesTheBusienssDo: Nullable<string>;
  streetAddress: Nullable<string>;
  city: Nullable<string>;
  stateOrProvince: Nullable<string>;
  postCode: Nullable<string>;
  country: Nullable<string>;
  corporateAccountingPeriod: Nullable<string>;
  dateOfIncorporation: Nullable<string>;
  endOfTaxYear: Nullable<string>;
  countryOfIncorporation: Nullable<string>;
  corporationForeignTaxIdNumberifAny: Nullable<string>;
  haveYouFiledForm8858Or8832InThePast: Nullable<TYesOrNo>;
  areYouPersonallyResponsibleForTheCorporateFilingInTheCountryOfIncorporation: Nullable<TYesOrNo>;
  foreignAgentOfCorporationNameAddressAndCountryOfLocation: Nullable<string>;
  custodianOfCorporateAccountingRecordsNameAdressAndCountry: Nullable<string>;
  dateYouAcquiredAtLeastA10OwnershipInTheCorporation: Nullable<string>;
  didYouAcquireOrDisposeOfSharesDuringYearYear: Nullable<TYesOrNo>;
  pleaseProvideDetails: Nullable<string>;
  areYouADirectorOfTheCorporationYear: Nullable<TYesOrNo>;
  areYouAnOfficerOfTheCorporationYear: Nullable<TYesOrNo>;
  doesYourSpouseOwnSharesInTheSameCorporation: Nullable<TYesOrNo>;
  spouseName: Nullable<string>;
  spouseTaxIdifAvailable: Nullable<string>;
  numberOfSharesYourSpouseOwnsInCorporationifAny: Nullable<string>;
  totalNumberOfIssuedSharesInTheCorporation: Nullable<string>;
  doAllUsOwnersCollectivelyOwnMoreThan50: Nullable<TYesOrNo>;
  pleaseProvideDetailsAboutAllUsOwnersincludingYourselfOfTheCorporationInTheTableBelow: TPleaseProvideDetailsAboutAllUsOwnersincludingYourselfOfTheCorporationInTheTableBelow;
  pleaseProvideDetailsAboutAllNonUsOwnersInTheTableBelow: TPleaseProvideDetailsAboutAllNonUsOwnersInTheTableBelow;
  doTheNonUsShareholdersOwnAUsPartnershipUsTrustAreABeneficiaryOfAUsTrustOrOwn50OrMoreOfASeparateUsCorporation: Nullable<TYesOrNo>;
  pleaseProvideDetailsAboutAllNonUsOwnersOwnershipOfSeparateEntititesInTheTableBelow: TPleaseProvideDetailsAboutAllNonUsOwnersOwnershipOfSeparateEntititesInTheTableBelow;
  didTheCorporationPayYouASalaryInYear: Nullable<TYesOrNo>;
  salaryPaidToYouByTheCorporationForYear: Nullable<string>;
  currency: Nullable<string>;
  didTheCorporationExtendYouAnyLoansInYear: Nullable<TYesOrNo>;
  didTheCorporationExtendYouAnyLoansInYearWhatWasTheAmount: Nullable<string>;
  didYouLoadAnyFundsToTheCorporationInYear: Nullable<TYesOrNo>;
  didYouLoadAnyFundsToTheCorporationInYearWhatWasTheAmount: Nullable<string>;
  didYouTransferPropertyOrCashToTheCorporationInYear: Nullable<TYesOrNo>;
  whichAssestDidYouTransfer: Nullable<string>;
  howMuchDidYouTransfer: Nullable<string>;
  didYouReceiveDividendsOrOtherDistributionsFromTheCorporationDuringYear: Nullable<TYesOrNo>;
  pleaseDescribeDistributionAndAmount: Nullable<string>;
  doesTheCorporationHaveAnyInvestmentIncome: Nullable<TYesOrNo>;
  areYouASignatoryAuthorityOnTheCorporateBankAccountsOrOtherFinancialAccounts: Nullable<TYesOrNo>;
  pleaseInputTheseAccountsInTheToeNonUsFinancialAccountsTablinkButton: Nullable<string>;
  willYouFileForm5471OnBehalfOfAnyOtherUsShareholder: Nullable<TYesOrNo>;
  wasForm5471FiledOnYourBehalfByAnotherUsOfficerdirectorOfThisForeignCorporation: Nullable<TYesOrNo>;
  uploadACopyOfTheForm5471FiledOnYourBehalf: Nullable<string>;
  pleaseUploadDocumentShowingCoprorateDetailsDateOfIncorporationAndShareOwnershipForAllShareholders: Nullable<string>;
  pleaseUploadCorporationBalanceSheet: Nullable<string>;
  pleaseUploadTheCorporationsIncomeStatement: Nullable<string>;
  haveYouFiledForm5471Or8865Before: Nullable<TYesOrNo>;
  pleaseUploadLastFiledForm5471Or8865: Nullable<string>;
  isTheCorporationEngagedInBusinessInTheUsOrDoesItHaveAnyIncomeFromUsSources: Nullable<TYesOrNo>;
  endOfForeignCorp1StRecord: Nullable<string>;
  YeardidTheCorporationPayYouASalaryIn: Nullable<TYesOrNo>;
}

export interface NonUsCorpOfPartnershipState {
  values: NonUsCorpOfPartnershipStateValues;
}

const initialState: NonUsCorpOfPartnershipState = {
  values: {
    nameOfCorporation: null,
    whatDoesTheBusienssDo: null,
    streetAddress: null,
    city: null,
    stateOrProvince: null,
    postCode: null,
    country: null,
    corporateAccountingPeriod: null,
    dateOfIncorporation: null,
    endOfTaxYear: null,
    countryOfIncorporation: null,
    corporationForeignTaxIdNumberifAny: null,
    haveYouFiledForm8858Or8832InThePast: null,
    areYouPersonallyResponsibleForTheCorporateFilingInTheCountryOfIncorporation:
      null,
    foreignAgentOfCorporationNameAddressAndCountryOfLocation: null,
    custodianOfCorporateAccountingRecordsNameAdressAndCountry: null,
    dateYouAcquiredAtLeastA10OwnershipInTheCorporation: null,
    didYouAcquireOrDisposeOfSharesDuringYearYear: null,
    pleaseProvideDetails: null,
    areYouADirectorOfTheCorporationYear: null,
    areYouAnOfficerOfTheCorporationYear: null,
    doesYourSpouseOwnSharesInTheSameCorporation: null,
    spouseName: null,
    spouseTaxIdifAvailable: null,
    numberOfSharesYourSpouseOwnsInCorporationifAny: null,
    totalNumberOfIssuedSharesInTheCorporation: null,
    doAllUsOwnersCollectivelyOwnMoreThan50: null,
    pleaseProvideDetailsAboutAllUsOwnersincludingYourselfOfTheCorporationInTheTableBelow:
      [
        {
          name: null,
          ssn: null,
          address: null,
          SharesOwnedAtBeginningOfAccountingPeriod: null,
          VotingPower: null,
        },
      ],
    pleaseProvideDetailsAboutAllNonUsOwnersInTheTableBelow: [
      {
        name: null,
        address: null,
        SharesOwnedAtBeginningOfAcountingPeriod: null,
        SharesOwnedAtEndOfAccountingPeriod: null,
        ifEntitynotAPersonCountryOfIncorporation: null,
        relationToYouifAny: null,
      },
    ],
    doTheNonUsShareholdersOwnAUsPartnershipUsTrustAreABeneficiaryOfAUsTrustOrOwn50OrMoreOfASeparateUsCorporation:
      null,
    pleaseProvideDetailsAboutAllNonUsOwnersOwnershipOfSeparateEntititesInTheTableBelow:
      [
        {
          nonUsOwnerName: null,
          entityName: null,
          entityAddress: null,
          ownershipOrInterestInTrustAsABeneficiary: null,
        },
      ],
    YeardidTheCorporationPayYouASalaryIn: null,
    didTheCorporationPayYouASalaryInYear: null,
    salaryPaidToYouByTheCorporationForYear: null,
    currency: null,
    didTheCorporationExtendYouAnyLoansInYear: null,
    didTheCorporationExtendYouAnyLoansInYearWhatWasTheAmount: null,
    didYouLoadAnyFundsToTheCorporationInYear: null,
    didYouLoadAnyFundsToTheCorporationInYearWhatWasTheAmount: null,
    didYouTransferPropertyOrCashToTheCorporationInYear: null,
    whichAssestDidYouTransfer: null,
    howMuchDidYouTransfer: null,
    didYouReceiveDividendsOrOtherDistributionsFromTheCorporationDuringYear:
      null,
    pleaseDescribeDistributionAndAmount: null,
    doesTheCorporationHaveAnyInvestmentIncome: null,
    areYouASignatoryAuthorityOnTheCorporateBankAccountsOrOtherFinancialAccounts:
      null,
    pleaseInputTheseAccountsInTheToeNonUsFinancialAccountsTablinkButton: null,
    willYouFileForm5471OnBehalfOfAnyOtherUsShareholder: null,
    wasForm5471FiledOnYourBehalfByAnotherUsOfficerdirectorOfThisForeignCorporation:
      null,
    uploadACopyOfTheForm5471FiledOnYourBehalf: null,
    pleaseUploadDocumentShowingCoprorateDetailsDateOfIncorporationAndShareOwnershipForAllShareholders:
      null,
    pleaseUploadCorporationBalanceSheet: null,
    pleaseUploadTheCorporationsIncomeStatement: null,
    haveYouFiledForm5471Or8865Before: null,
    pleaseUploadLastFiledForm5471Or8865: null,
    isTheCorporationEngagedInBusinessInTheUsOrDoesItHaveAnyIncomeFromUsSources:
      null,
    endOfForeignCorp1StRecord: null,
  },
};

const nonUsCorpOfPartnershipSlice = createSlice({
  name: 'nonUsCorpOfPartnership',
  initialState,
  reducers: {
    update(state, action: PayloadAction<NonUsCorpOfPartnershipStateValues>) {
      state.values = JSON.parse(JSON.stringify(action.payload));
    },
    updateKey(
      state,
      action: PayloadAction<{
        key: keyof NonUsCorpOfPartnershipStateValues | UpdateFieldArrayKeysKeys;
        value: any;
      }>,
    ) {
      lodashSet(state, `values.${action.payload.key}`, action.payload.value);
    },
    updateFieldArrayKey(
      state,
      action: PayloadAction<{
        key: keyof NonUsCorpOfPartnershipStateValues | UpdateFieldArrayKeysKeys;
        value: UpdateFieldArrayValue;
      }>,
    ) {
      const fieldArray = action.payload.value.map((field: any) => ({
        ...field,
      }));
      if (
        action.payload.key ===
          'pleaseProvideDetailsAboutAllNonUsOwnersInTheTableBelow' ||
        action.payload.key ===
          'pleaseProvideDetailsAboutAllUsOwnersincludingYourselfOfTheCorporationInTheTableBelow' ||
        action.payload.key ===
          'pleaseProvideDetailsAboutAllNonUsOwnersOwnershipOfSeparateEntititesInTheTableBelow'
      )
        state.values[action.payload.key] = fieldArray;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      questionnairesApi.endpoints.getQuestionnaireById.matchFulfilled,
      (state, { payload }) => {
        state.values = payload.questionnaire.data.taxQuestionnaire
          ? payload.questionnaire.data.taxQuestionnaire.income.corporationTrust
              .nonUsCorpOfPartnership.values
          : initialState.values;
      },
    );
  },
});

export const { update, updateKey, updateFieldArrayKey } =
  nonUsCorpOfPartnershipSlice.actions;
export default nonUsCorpOfPartnershipSlice.reducer;

export const selectNonUsCorpOfPartnership = (state: RootState) =>
  state.taxQuestionnaire.income.corporationTrust.nonUsCorpOfPartnership;
